import type { ReactNode } from 'react';

interface Props {
  title: string;
  children: ReactNode;
  /** Optional right-aligned header slot (e.g. "Create new" button). */
  actions?: ReactNode;
}

/**
 * Presentational wrapper for full-page galleries. Provides the page title
 * bar, a max-width container, and a slot for future per-gallery actions.
 */
export function GalleryView({ title, children, actions }: Props) {
  return (
    <div className="gallery-page">
      <header className="gallery-page-header">
        <h2>{title}</h2>
        <div className="spacer" />
        {actions}
      </header>
      <div className="gallery-page-body">{children}</div>
    </div>
  );
}
